import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useState } from 'react'

import { getStoredConsent, initAnalytics, setStoredConsent } from './analytics'

// Deliberately plain — inherits your MUI theme. Restyle to taste.
export function CookieConsent() {
  const [open, setOpen] = useState(() => getStoredConsent() === null)

  if (!open) return null

  const accept = () => {
    setStoredConsent('granted')
    initAnalytics()
    setOpen(false)
  }

  const decline = () => {
    setStoredConsent('denied')
    setOpen(false)
  }

  return (
    <Paper
      id="cookie-consent"
      elevation={6}
      role="dialog"
      aria-label="Cookie consent"
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        mx: 'auto',
        p: 2,
        maxWidth: 640,
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{
          alignItems: { sm: 'center' },
          justifyContent: "space-between"
        }}>
        <Typography variant="body2">
          We use cookies to analyse site traffic and improve your experience.
          You can accept or decline analytics cookies.
        </Typography>
        <Box sx={{ flexShrink: 0 }}>
          <Button size="small" onClick={decline} sx={{ mr: 1 }}>
            Decline
          </Button>
          <Button size="small" variant="contained" onClick={accept} id="cookie-consent-button">
            Accept
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}
